<template>
  <v-snackbar
    v-model="state"
    :timeout="time"
    :top="top"
    class="snackbar-custom"
    :multi-line="mode"
  >
    <v-flex class="pr-3">
      <v-icon style="color:#fff;" class="mr-1">notification_important</v-icon>
    </v-flex>
    <v-flex v-html="msg"></v-flex>
    <v-btn dark flat @click="state = false" >
      <v-icon>close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import EventBus from '@/utile/eventBus'

export default {
  name: 'Alert',
  data: () => ({
    state: false,
    msg: '',
    color: '#494949',
    time: 2500,
    top: true,
    mode: true
  }),
  mounted () { // 시작
    // 업데이트 버스
    EventBus.$on('alert', (msg) => {
      this.msg = msg
      this.state = true
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/utile/Alert.vue